export const en = {
  "application.examLocationAndDate.chkeckingAvailabilityOfExams": "Checking availability of exams. Please wait...",
  "application.examLocationAndDate.dateColumn": "Date",
  "application.examLocationAndDate.examColumn": "Exam",
  "application.examLocationAndDate.examFull": "Unfortunately, all places are fully booked already. We recommend to register for the waiting list.",
  "application.examLocationAndDate.examTypeColumn": "Exam type",
  "application.examLocationAndDate.languageColumn": "Language",
  "application.examLocationAndDate.locationColumn": "Location",
  "application.examLocationAndDate.moduleColumn": "Module",
  "application.examLocationAndDate.statusColumn": "Status",
  "application.examLocationAndDate.validattion.examsHaveDifferentLocations": "It is not possible to book exams at different locations on the same day. Please adjust your selection.",
  "application.examLocationAndDateExplanationText": "Please select location and date for the selected exams.",
  "application.moduleSelector.examsColumn": "Exams",
  "application.moduleSelector.noAvaiableModules": "No available modules",
  "application.moduleSelector.typeColumn": "Type",
  "application.selectedExamsTitle": "Selected modules and exams",
  "application.uploadVerificationFilesMessage": "Please, upload your files for verification",
  "application.userSelector.course": "Course",
  "application.userSelector.examSession": "Exam session",
  "application.userSelector.noSelectedModules": "No selected modules",
  "cancellationTaskForm.candidateSubHeader": "Candidate",
  "cancellationTaskForm.certificationTypeLabel": "Certification Type",
  "cancellationTaskForm.commentsLabel": "Comments",
  "cancellationTaskForm.completeTask": "Save and complete the task",
  "cancellationTaskForm.createdOn": "Created on",
  "cancellationTaskForm.dateLabel": "Date",
  "cancellationTaskForm.emailLabel": "Email",
  "cancellationTaskForm.examTypeLabel": "Exam Type",
  "cancellationTaskForm.firstNameLabel": "First Name",
  "cancellationTaskForm.header": "Cancellation Task",
  "cancellationTaskForm.lastNameLabel": "Last Name",
  "cancellationTaskForm.locationLabel": "Location",
  "cancellationTaskForm.moduleSubHeader": "Module",
  "cancellationTaskForm.navigateToCandidateSession": "Go to candidate's certification page",
  "cancellationTaskForm.roomLabel": "Room",
  "cancellationTaskForm.sessionLabel": "Session",
  "cancellationTaskForm.timeSlotLabel": "Time Slot",
  "candidate.button.exportAll": "Export all candidates",
  "candidate.button.new": "Add new Candidate",
  "candidate.button.uploadEdiIds": "Upload EDI Ids",
  "candidate.disableConfirmationDialog.message": "Please make sure your personal details are correct, as they cannot be changed afterwards.",
  "candidate.ediIdsDialog.title": "Upload the file that contains the EDI Ids",
  "candidate.ediIdsDialog.uploadSuccess": "Upload success. Number of updated candidates:",
  "candidate.field.canton": "Canton",
  "candidate.field.correspondenceLanguage": "Correspondence Language",
  "candidate.field.invoiceRecipient": "Invoice Recipient",
  "candidate.field.nationality": "Nationality",
  "candidate.field.numberOfFailedOralExams": "Failed oral exams",
  "candidate.field.numberOfFailedWrittenExams": "Failed written exams",
  "candidate.field.placeOfOrigin": "Place of Origin",
  "candidate.header": "Candidates",
  "candidate.section.invoice": "Invoice",
  "candidate.snackbar.successfulCreate": "The Candidate was added successfully.",
  "candidate.snackbar.successfulDelete": "The Candidate was deleted successfully.",
  "candidate.snackbar.successfulExport": "The abacus debtor number has been scheduled to export.",
  "candidate.snackbar.successfulUpdate": "The Candidate was updated successfully.",
  "candidate.validation.disabledFields": "Fields can not be updated after confirmation",
  "candidate.validation.idNotEmpty": "The candidate ID can not be empty.",
  "candidateAssignment.validation.preparationRoomNotAllowed.": "A candidate can't be assigned to a preparation room.",
  "candidateCourse.certificate.fileNamePrefix": "Certificate",
  "candidateCourse.performanceRecord.fileNamePrefix": "Performance Record",
  "candidateCourseStatus.open": "Open",
  "candidateCourseStatus.passed": "Passed",
  "candidateWizard.error": "The registration for the certification failed.",
  "candidateWizard.success": "Success! You should have received one email for each booking and your exams will appear on the Candidate view.",
  "canton.ag": "Aargau",
  "canton.ai": "Appenzell Inner-Rhodes",
  "canton.ar": "Appenzell Outer-Rhodes",
  "canton.be": "Bern",
  "canton.bl": "Basel District",
  "canton.bs": "Basel",
  "canton.fr": "Fribourg",
  "canton.ge": "Geneva",
  "canton.gl": "Glarus",
  "canton.gr": "Grisons",
  "canton.ju": "Jura",
  "canton.lu": "Lucerne",
  "canton.ne": "Neuenburg",
  "canton.nw": "Nidwalden",
  "canton.ow": "Obwalden",
  "canton.sg": "St. Gallen",
  "canton.sh": "Schaffhausen",
  "canton.so": "Solothurn",
  "canton.sz": "Schwyz",
  "canton.tg": "Thurgau",
  "canton.ti": "Ticino",
  "canton.ur": "Uri",
  "canton.vd": "Vaud",
  "canton.vs": "Valais",
  "canton.zg": "Zug",
  "canton.zh": "Zurich",
  "cart.validation.candidateIdNotEmpty": "Candidate Id cannot be empty.",
  "cart.validation.cartEmpty": "Cart is empty.",
  "cart.validation.examAlreadyBooked": "Exam already booked.",
  "cart.validation.examNotFound": "Exam not found.",
  "cart.validation.missingCourseId": "Missing Course ID",
  "cart.validation.missingExamDayIdOnExam": "Missing exam day ID on exam.",
  "cart.validation.missingExamSessionId": "Missing exam session ID",
  "cart.validation.missingInformationInModule": "Missing information in module.",
  "cart.validation.missingModuleId": "Missing Module ID",
  "cart.validation.moduleAlreadyBooked": "Module already booked.",
  "cart.validation.moduleAlreadyPaid": "Module already paid.",
  "cart.validation.moduleNotFound": "Module not found in cart.",
  "certification.button.new": "Exam Registration",
  "certification.examDate": "Exam Date",
  "certification.examType": "Exam Type",
  "certification.fachrichtung": "Oral exam option",
  "certification.state": "State",
  "certifications.noInfo": "No certifications found",
  "common.accept": "Accept",
  "common.archive": "Archive",
  "common.attention": "Attention",
  "common.build": "Build",
  "common.business": "business",
  "common.cancel": "Cancel",
  "common.certificationsGenerated": "Certifications generated",
  "common.close": "Close",
  "common.comment": "Comment",
  "common.confirmArchiveDescription": "Do you really want to archive the entity?",
  "common.confirmDeleteDescription": "Do you really want to delete the entity?",
  "common.confirmPublishDescription": "Are you sure you want to publish this entity?",
  "common.copyToClipboard": "Copy to clipboard",
  "common.copyToClipboardDone": "Copied to clipboard",
  "common.debtorNumber": "Debtor number",
  "common.delete": "Delete",
  "common.dragAndDrop.description": "Drag & Drop the document here",
  "common.errorMessage": "Something went wrong",
  "common.exam": "Exam",
  "common.export": "Export",
  "common.field.status": "Status",
  "common.genders.female": "Female",
  "common.genders.male": "Male",
  "common.generateCertifications.confirmation": "Are you sure you want to generate certifications?",
  "common.generateCertifications": "Generate Certifications",
  "common.info": "Information",
  "common.language.de": "German",
  "common.language.en": "English",
  "common.language.fr": "French",
  "common.language.it": "Italian",
  "common.language": "Language",
  "common.languages": "Languages",
  "common.lastModification.by": "by",
  "common.lastModification.on": "on",
  "common.lastModification": "Last modified",
  "common.module": "Module",
  "common.no": "no",
  "common.noLanguagesAssigned": "No languages assigned",
  "common.ok": "Ok",
  "common.orderId": "Order Id",
  "common.pleaseSelect": "Please select",
  "common.private": "private",
  "common.publish": "Publish",
  "common.reject": "Reject",
  "common.rejected": "Rejected",
  "common.roomLanguage": "Room language",
  "common.roomType": "Room type",
  "common.rowsPerPage": "Rows per page:",
  "common.save": "Save",
  "common.scheduleCorrectionExams": "Correction planning",
  "common.scheduleOralExams": "Schedule oral exams",
  "common.scheduleWrittenExams": "Schedule written exams",
  "common.search": "Search",
  "common.selectElement": "Select a",
  "common.selectElements": "Select",
  "common.signOut": "Sign Out",
  "common.status.archived": "Archived",
  "common.status.cancelled": "Cancelled",
  "common.status.deleted": "Deleted",
  "common.status.draft": "Draft",
  "common.status.published": "Published",
  "common.survey": "Survey",
  "common.timeSlotStructure": "Time Slot Structure",
  "common.total": "Total",
  "common.transaction.failMessage.declined": "You are not allowed to pay with this payment method. Please try different.",
  "common.transaction.id": "Transaction Id",
  "common.unexpectedError": "Unexpected error. Please, try again later.",
  "common.Unknown": "Unknown",
  "common.unpublish": "Unpublish",
  "common.uploadError": "Upload error. The format of the file is not valid.",
  "common.uploadSizeError": "Upload error. The file exceeds the maximum size of {size}MB.",
  "common.validation.entityWithIdNotExistsAndCanNotBeAssigned": "The Entity with the given ID was not found and can't be assigned.",
  "common.validation.entityWithIdNotExistsAndCanNotBeDeleted": "The Entity with the given ID was not found and can't be deleted.",
  "common.validation.idNotEmpty": "The ID can't be empty.",
  "common.validation.name.empty": "The name can't be empty.",
  "common.validation.status.empty": "Status should not be empty.",
  "common.validation.status.invalidTransition": "This status transition is invalid.",
  "common.validation.status.invalidValue": "Incorrect status value.",
  "common.yes": "yes",
  "countries.switzerland.name": "Schweiz",
  "course.button.addModules": "Add modules",
  "course.dialog.confirmPublishDescription": "Are you sure you want to publish this Course?",
  "course.dialog.noAvailableModules": "No modules available.",
  "course.dialog.selectModules": "Select modules",
  "course.field.certificateValidity.FiveYears": "5 years",
  "course.field.certificateValidity.Unlimited": "Unlimited",
  "course.field.certificateValidity": "Validity of the certification",
  "course.field.moduleRelevantForGrade": "Relevant for course grade",
  "course.field.modulesValidity.days": "days",
  "course.field.modulesValidity.unlimited": "Unlimited",
  "course.field.modulesValidity": "Modules validity",
  "course.field.name": "Course name",
  "course.field.nameDE": "Course name - DE",
  "course.field.nameEN": "Course name - EN",
  "course.field.nameFR": "Course name - FR",
  "course.field.nameIT": "Course name - IT",
  "course.field.numberOfMandatoryModules": "Number of mandatory modules",
  "course.field.numberOfProcessModules": "Number of process modules",
  "course.field.numberOfSelectionModules": "Number of selection modules",
  "course.header": "Course",
  "course.list.header": "Courses",
  "course.section.modules": "Modules",
  "course.snackbar.successfulArchive": "The Course was archived successfully.",
  "course.snackbar.successfulDelete": "The Course was deleted successfully.",
  "course.snackbar.successfulPublish": "The Course was published successfully.",
  "course.type.cicero": "Professional certificate/Cicero",
  "course.type.ciceroGroup": "Professional certificate/Cicero group",
  "course.type.hve": "HVE",
  "course.type.hveGroup": "HVE group",
  "course.type.intermediary": "Intermediary",
  "course.type.intermediaryGroup": "Intermediary group",
  "course.type.mindeststandard": "Minimum standards",
  "course.type.mindeststandardGroup": "Minimum standards group",
  "course.type": " Course type",
  "course.validation.idNotEmpty": "The Course ID can't be empty.",
  "course.validation.modules.empty": "Please select at least one module.",
  "course.validation.numberOfAnyModulesIsZero": "Total number of modules must be at least 1.",
  "course.validation.typeIsInvalid": "The course type is invalid.",
  "course.validation.typeNotEmpty": "Please select the course type",
  "courseManagement.header": "Courses",
  "dragAndDrop.uploadFiles": "Upload the files by dropping them here",
  "exam.button.new": "Add new exam",
  "exam.field.correctionExpenses": "Correction expenses",
  "exam.field.courseType": "Course Type",
  "exam.field.examExpenses": "Exam expenses",
  "exam.field.examId": "Exam ID",
  "exam.field.examName": "Exam name",
  "exam.field.examNameDE": "Exam name DE",
  "exam.field.examNameEN": "Exam name EN",
  "exam.field.examNameFR": "Exam name FR",
  "exam.field.examNameIT": "Exam name IT",
  "exam.field.expertExpenses": "Expenses for experts",
  "exam.field.type": "Exam type",
  "exam.header": "Exams",
  "exam.section.specifics": "Exam specifics",
  "exam.snackbar.successfulArchive": "The Exam was archived successfully.",
  "exam.snackbar.successfulDelete": "The Exam was deleted successfully.",
  "exam.snackbar.successfulPublish": "The Exam was published successfully.",
  "exam.type.oral": "Oral exam",
  "exam.type.termPaper": "Term paper",
  "exam.type.written": "Written exam",
  "exam.validation.idNotEmpty": "The Exam ID can't be empty",
  "examApplication.field.candidates": "Candidates",
  "examApplication.field.case": "Case",
  "examApplication.validation.timeslotIsOverbooked": "At least one exam is overbooked. This can happen if new applications are added while changes are being made in the planning view.",
  "examAssignment.validation.preparationRoomNotAllowed": "An exam can't be assigned to a preparation room.",
  "examDay.button.assignExpertsToCorrectionExams": "Assign correction expert",
  "examDay.button.assignExpertsToOralExams": "Assign experts to oral exams",
  "examDay.button.assignProctorsToOralPreparations": "Assign proctors to oral preparations",
  "examDay.button.assignProctorsToWrittenExams": "Assign proctors to written exams",
  "examDay.button.new": "Add new Exam Day",
  "examDay.field.date": "Date",
  "examDay.field.header": "Exam Day",
  "examDay.field.numberOfRoomsAssigned": "Rooms assigned",
  "examDay.field.preparationRoom": "Preparation Room",
  "examDay.field.timeSlotStructure.correction": "Correction",
  "examDay.field.timeSlotStructure.electiveWritten": "Elective written",
  "examDay.field.timeSlotStructure.mandatoryWritten": "Mandatory written",
  "examDay.field.timeSlotStructure.oralHBB_ProcessModule": "Oral HBB process modul",
  "examDay.field.timeSlotStructure.oralIntermediary": "Oral intermediary",
  "examDay.field.timeSlotStructure.oralLife": "Exam part life",
  "examDay.field.timeSlotStructure.placeholder": "Time slot structure",
  "examDay.field.timeSlotStructure.writtenHBB_ProcessModule": "Written HBB process modul",
  "examDay.field.timeSlotStructure.writtenIntermediary": "Written intermediary",
  "examDay.field.timeSlotStructure": "Time slot structure",
  "examDay.field.type.correction": "Correction",
  "examDay.field.type.oral": "Oral",
  "examDay.field.type.written": "Written",
  "examDay.field.type": "Type",
  "examDay.validation.alreadyExistsForLocationOnSameDate": "Another Exam Day with the same date and location already exists.",
  "examDay.validation.examTypeUnknown": "The Exam Type is unknown. Please choose an existing type.",
  "examDay.validation.idNotEmpty": "The Exam Day ID can't be empty.",
  "examDay.validation.notFound": "Exam day not found.",
  "examDay.validation.onlyOnePreparationRoomAllowed": "Only one preparation room can be added to the day.",
  "examDay.validation.roomCanNotBeAssignedToSelectedExamType": "The Room can't be assigned because it's not applicable to the Exam Type of this Exam Day.",
  "examDay.validation.selectedRoomAlreadyAssigned": "The Room is already assigned.",
  "examDay.validation.selectedRoomIsPcRoomAndCanNotBeUsed": "The Room is a computer room and can't be assigned.",
  "examManagement.header": "Exams",
  "examScore.grade": "Grade",
  "examScore.points": "Points",
  "examSession.alert.builderInformation": "Please be aware that the selected exam will be added on all selected days to all selected locations. After creating the session you will be able to see and edit manually all entered data. The start date of the registration is automatically today and the start time 10am.",
  "examSession.button.calculateExamResults": "Calculate exam results",
  "examSession.button.exportCandidates": "Export Candidates by exam type and time slot",
  "examSession.button.exportOrders": "Export missing orders XML",
  "examSession.button.importExamScoresAndGrades": "Import Scores and Grades",
  "examSession.button.importPev": "Import PEV",
  "examSession.button.new": "Add a new Exam Session",
  "examSession.button.newBuilder": "Add using builder",
  "examSession.button.newLife": "Add a new Life Exam Session",
  "examSession.button.publishExamResults": "Publish exam results",
  "examSession.candidateExportDialog.examDay.label": "Date",
  "examSession.candidateExportDialog.examDay.placeholder": "Select a date",
  "examSession.candidateExportDialog.timeSlot.label": "Time Slot",
  "examSession.candidateExportDialog.timeSlot.placeholder": "Select a time slot",
  "examSession.candidateExportDialog.title": "Select an exam type and, optionally, a date and time slot",
  "examSession.confirmPublishResultsDialog.text": "Are you sure you want to publish the exam results of this session?",
  "examSession.dialog.noAvailableCourses": "This exam is not assigned to any course",
  "examSession.dialog.selectCourseTypes": "Select Course Types",
  "examSession.field.candidatePin": "Candidate PIN",
  "examSession.field.correctionPeriod": "Correction period",
  "examSession.field.date": "Date",
  "examSession.field.examResultDate": "Exam result date",
  "examSession.field.examSession": "Examination period",
  "examSession.field.examSessionDate": "Exam session date",
  "examSession.field.expertPin": "Expert PIN",
  "examSession.field.freeCancellationEndDate": "Free of charge cancellation until",
  "examSession.field.from": "From",
  "examSession.field.gradingConferenceDate": "Date of grading conference",
  "examSession.field.hidePastSessions": "Hide past sessions",
  "examSession.field.inspectionPeriod": "Inspection",
  "examSession.field.inspectionSignupEndDate": "Inspection signup end date",
  "examSession.field.isLife": "Life exam",
  "examSession.field.lifeSessionsOnly": "Life sessions only",
  "examSession.field.published": "Published",
  "examSession.field.sessionKey": "Session Key",
  "examSession.field.sessionKeyDE": "Exam session DE",
  "examSession.field.sessionKeyEN": "Exam session EN",
  "examSession.field.sessionKeyFR": "Exam session FR",
  "examSession.field.sessionKeyIT": "Exam session IT",
  "examSession.field.signup": "Signup date",
  "examSession.field.signupDate": "Signup Date",
  "examSession.field.signupEndDate": "Sign up End Date",
  "examSession.field.signupStartDate": "Sign up Start Date",
  "examSession.field.surveyDeadline": "Survey deadline",
  "examSession.field.to": "To",
  "examSession.header": "Exam Sessions",
  "examSession.importPevDialog.title": "Upload the file that contains PEV data",
  "examSession.invitation.allLocations": "All locations",
  "examSession.invitation.flagged": "Email/s has already been sent for this location",
  "examSession.invitation.selectLocations": "Select locations",
  "examSession.invitation.snackbar.candidates": "Invitations sent to {count} candidates.",
  "examSession.invitation.snackbar.experts": "Invitations sent to {count} experts.",
  "examSession.invitation": "Invite Experts/Candidates",
  "examSession.label.examSessionBuilder": "Exam session builder",
  "examSession.label.revealCandidatePin": "Reveal candidate PIN",
  "examSession.label.revealExpertPin": "Reveal expert PIN",
  "examSession.mail.invitation": "Send Invitation",
  "examSession.mail.notifyCandidates": "Notify Candidates",
  "examSession.mail.survey": "Start Survey",
  "examSession.result.examSessionCreated": "Exam session created",
  "examSession.result.NotGenerated": "Exam results have not been generated yet.",
  "examSession.select.assignNewLocation": "Assign a new location",
  "examSession.validation.atLeastOneLanguageIsSelectedForEachRoom": "At least one language must be selected for each room.",
  "examSession.validation.betweenFromAndTo": "Sign up timespan must be between the From and To dates.",
  "examSession.validation.canNotBeDeletedBecauseLocationsInside": "The Exam Session cannot be deleted because of one or more assigned locations.",
  "examSession.validation.canNotBeUnpublishedBecauseExistingApplication": "Exam Session cannot be unpublished because already existing Exam Applications.",
  "examSession.validation.canNotReapplyForDifferentLanguage": "You cannot re-apply for the same Exam Session with a different language.",
  "examSession.validation.correctionEndDateLaterThanCorrectionStartDate": "The Correction End Date must be later than the Correction Start Date.",
  "examSession.validation.examsEndDateLaterThanExamsStartDate": "The Exams End Date must be later than the Exams Start Date.",
  "examSession.validation.examSessionFull": "The selected exam in this exam session is unfortunately fully booked in the meantime. Please select another module or another examination session.",
  "examSession.validation.examsNoCourseTypes": "Some written or oral exams do not have any course type assigned. Please assign at least one course type.",
  "examSession.validation.examWithNotAllowedCourseTypes": "Some exams have not valid course types assigned. Please ensure all assignments are correct or reload the page.",
  "examSession.validation.freeCancellationNotPossible": "Free cancellation is no longer available.",
  "examSession.validation.idNotEmpty": "The Exam Session ID can't be empty.",
  "examSession.validation.inspectionEndDateLaterThanInspectionStartDate": "The Inspection End Date must be later than the Inspection Start Date.",
  "examSession.validation.locationAlreadyExists": "The Location already exists in Exam Session.",
  "examSession.validation.locationDoesNotExist": "The Location was not found.",
  "examSession.validation.nameIsRequiredInAllLanguages": "The Exam Session name is required in all languages.",
  "examSession.validation.noExamFoundToSignup": "No exam found to signup.",
  "examSession.validation.notPublishedNoSurveyPossible": "Survey can only be started if exam session is published",
  "examSession.validation.notPublishedResultsPublishingNotPossible": "Exams results publishing is not possible because exam session is not published.",
  "examSession.validation.publishedNoUpdatePossible": "The Exam Session is published and can't be updated.",
  "examSession.validation.signupEndDateLaterThanSignupStartDate": "The Sign up End Date must be later than the Sign up Start Date.",
  "examSession.validation.signupStartDateLaterThanOrEqualFrom": "The Sign up Start Date must be equal or later than the From Date.",
  "examSession.validation.someErrorsOccurred": "Some modules have errors",
  "examSession.validation.toLaterThanFrom": "The exam end date must be later than the exam start date.",
  "examSession.validation.toLaterThanSignupEndDate": "The exam end date must be later than the sign up end date.",
  "examSession.validation.toLaterThanSignupStartDate": "The exam end date must be later than the sign up start date.",
  "examSession.validation.withSameNameAlreadyExists": "Another Exam Session with the same name exists already.",
  "examSession.writtenExamScoresImportDialog.title": "Upload the file that contains the Written Exams scores",
  "examSession.writtenExamScoresImportDialog.uploadSuccess": "Upload success. Number of updated scores:",
  "examSessionCandidate.addCandidate": "Add candidate",
  "examSessionCandidate.addDialog.bookingWithInvoice": "Booking with invoice",
  "examSessionCandidate.addDialog.candidate": "Candidate",
  "examSessionCandidate.addDialog.course": "Course",
  "examSessionCandidate.addDialog.module": "Module",
  "examSessionCandidate.addDialog.rebookWithInvoice": "Rebook with invoice",
  "examSessionCandidate.addDialog.title": "Select candidate, course and module",
  "examSessionCandidate.attachments": "Attachments",
  "examSessionCandidate.averageGrade": "Average grade",
  "examSessionCandidate.book": "Book",
  "examSessionCandidate.bookedBy": "Person who has made the booking",
  "examSessionCandidate.booking.error": "Your selection is no longer available. Please try again.",
  "examSessionCandidate.bookingAvailableWhenRebooked": "The exam selection will be avilable when the module is rebooked.",
  "examSessionCandidate.bookingDialog.selectDate": "Select a date",
  "examSessionCandidate.bookingDialog.selectLanguage": "Select a language",
  "examSessionCandidate.bookingDialog.selectLocation": "Select a location",
  "examSessionCandidate.bookingDialog.title": "Location and exam date",
  "examSessionCandidate.bookingTimestamp": "Time of booking",
  "examSessionCandidate.cancel": "Cancel",
  "examSessionCandidate.cancellationTimestamp": "Time of cancellation",
  "examSessionCandidate.cancelledBy": "Person who has made the cancellation",
  "examSessionCandidate.cancelModuleMessage": "Are you sure to cancel this module?",
  "examSessionCandidate.cancelModuleRefundInformation": "If inside the free cancellation period then the module will be refunded, else a cancellation task will be created.",
  "examSessionCandidate.certification": "Certification",
  "examSessionCandidate.exam": "Exam",
  "examSessionCandidate.examDate": "Exam Date",
  "examSessionCandidate.examType": "Exam Type",
  "examSessionCandidate.isRepeater": "Repeater",
  "examSessionCandidate.locationAndDateEdit": "Edit location and exam date",
  "examSessionCandidate.module": "Module",
  "examSessionCandidate.option": "Option",
  "examSessionCandidate.orderDetails": "Order details",
  "examSessionCandidate.paymentState": "Payment State",
  "examSessionCandidate.publishResultsToEmployer": "Pass on exam result",
  "examSessionCandidate.rebook": "Re-book",
  "examSessionCandidate.resetManualState": "Set state automatically",
  "examSessionCandidate.selectExamToRebook": "Select an exam to rebook",
  "examSessionCandidate.setManualState": "Set state manually",
  "examSessionCandidate.state": "State",
  "examSessionCandidate.validation.examAlreadyBookedForAnotherModule": "The exam is already booked for another module.",
  "examSessionCandidate.validation.examNotFound": "The Exam was not found.",
  "examSessionCandidate.validation.idNotEmpty": "The ExamSessionCandidate ID can't be empty.",
  "examSessionCandidate.validation.invalidGrade": "The grade is invalid.",
  "examSessionCandidate.validation.invalidScore": "The score is invalid.",
  "examSessionCandidate.verificationRequired": "Verification required",
  "examSessionCandidateExamState.booked": "Booked",
  "examSessionCandidateExamState.cancelled": "Cancelled",
  "examSessionCandidateExamState.equivalence": "Equivalence",
  "examSessionCandidateExamState.failed": "Exam failed",
  "examSessionCandidateExamState.passed": "Exam passed",
  "examSessionCandidateModuleState.applicationAccepted": "Application accepted",
  "examSessionCandidateModuleState.cancelled": "Cancelled",
  "examSessionCandidateModuleState.Cancelled": "Module cancelled. A system task has been created",
  "examSessionCandidateModuleState.equivalence": "Equivalence",
  "examSessionCandidateModuleState.expired": "Expired",
  "examSessionCandidateModuleState.failed": "Module failed",
  "examSessionCandidateModuleState.passed": "Module passed",
  "examSessionCandidateModuleState.Refunded": "Module refunded",
  "examSessionCandidateModuleState.verificationRequired": "Verification required",
  "examSessions.noInfo": "No exam sessions found",
  "examState.booked": "Booked",
  "examState.cancelled": "Cancelled",
  "examState.none": "---",
  "expert.button.new": "Add new Expert",
  "expert.field.courseType.placeholder": "Select course types for the role",
  "expert.field.exam.placeholder": "Select exams for the Role",
  "expert.field.exam": "Examen EN",
  "expert.field.languages": "Languages",
  "expert.field.role.add": "Add new role",
  "expert.field.role.Aufsichtsexperten": "Supervisory Experts",
  "expert.field.role.delete": "Delete role",
  "expert.field.role.EinspracheKomission": "Objection Commission",
  "expert.field.role.Expertenschulung": "Expert Training",
  "expert.field.role.Hauptexperten": "Key Experts",
  "expert.field.role.Leiterprüfungszentrum": "Ladder Testing Center",
  "expert.field.role.placeholder": "Select roles for the Expert",
  "expert.field.role.Prüfungsexperten": "Board of examiners",
  "expert.field.role.Prüfungskomission": "Review Commission",
  "expert.field.role.QSK": "Quality Guarantee Commission",
  "expert.field.role": "Roles",
  "expert.header": "Experts",
  "expert.snackbar.successfulCreate": "The Expert was added successfully.",
  "expert.snackbar.successfulDelete": "The created Expert was deleted.",
  "expert.snackbar.successfulUpdate": "The Expert was updated successfully.",
  "expert.validation.idNotEmpty": "The expert ID can not be empty.",
  "expertAssignment.validation.examNotAssignedToRoom": "Exam not assigned to room",
  "expertAssignment.validation.expertAssignedToMultipleRoomsOnSameDay": "Expert is assigned to multiple rooms on same day.",
  "expertAssignment.validation.expertNotRequiredRole": "Expert has not the required role.",
  "expertAssignment.validation.expertNotSpeakingAnySupportedLanguage": "Expert doesn't speak one of the supported languages.",
  "expertAssignment.validation.roomNotAssignedToExamDay": "Room not assigned to exam day.",
  "expertAvailability.header": "Availability",
  "expertAvailability.noDatesAvailable": "At the moment, there are no available dates",
  "expertAvailability.surveyDeadlinePassed": "The survey deadline has passed.",
  "expertCorrectionAvailability.header": "Availability for Exam Correction",
  "file.name": "File Name",
  "home.candidate": "Candidate view",
  "home.expert": "Expert view",
  "home.header": "Start Page",
  "home.me.edit": "Manage account",
  "home.me": "Me and my settings",
  "home.myAlertFields.link": "Please manage your account.",
  "home.myAlertFields": "Some mandatory account data is required.",
  "home.myCertifications": "My Certifications",
  "home.myCourses.downloadCertificate": "Certificate",
  "home.myCourses.downloadPerformanceRecord": "Performance record",
  "home.myCourses.table.ClosingDate": "Closing Date",
  "home.myCourses.table.downloads": "Downloads",
  "home.myCourses": "My Courses",
  "home.myExamCases": "My Exam Cases",
  "home.myExamResults": "My Exam Results",
  "home.myExams.newApplication": "Exam Registration",
  "home.myExams.noExams": "No exam found",
  "home.myExams.table.actionsColumn": "Actions",
  "home.myExams.table.dateColumn": "Date",
  "home.myExams.table.examColumn": "Exam",
  "home.myExams.table.examTypeColumn": "Exam Type",
  "home.myExams.table.gradeColumn": "Grade",
  "home.myExams.table.locationColumn": "Location",
  "home.myExams.table.moduleColumn": "Module",
  "home.myExams.table.roomColumn": "Room",
  "home.myExams.table.statusColumn": "State",
  "home.myExams.table.timeColumn": "Time",
  "home.myExams": "My Exams",
  "home.myExamSessions": "My Exam Sessions",
  "home.myFiles": "My Files",
  "home.myTasks": "My Tasks",
  "home.pendingItemsInCartMessage": "You still have unpaid modules. Would you like to continue the booking now? Please note that the place in a module is not reserved until payment has been made.",
  "home.switch.candidate": "Switch to candidate view",
  "home.switch.expert": "Switch to expert view",
  "icon.state.completed": "Completed",
  "icon.state.error": "Error",
  "icon.state.fullyBooked": "Fully booked",
  "icon.state.incomplete": "Incomplete",
  "icon.state.paid": "Paid",
  "import.pev.bookingFailed": "Can't book all candidates.",
  "import.pev.failedImportCandidates": "Failed to import candidates.",
  "import.pev.failedImportScoresAndGrades": "Failed to import scores and grades.",
  "import.pev.invalidCsv": "Invalid CSV file.",
  "import.pev.missingEntities": "Some entities were not found. Candidates IDs: {candidateIds}. Exam sessions IDs: {examSessionsIds}. Courses IDs: {courseIds}. Modules IDs: {moduleIds}. Exams IDs: {examIds}.",
  "import.pev.noExam": "Exam cannot be found. Exam ID: {examId}.",
  "import.pev.noExamDayForExam": "Can't find available exam day for the exam. Exam session ID: {examSessionId}. Exam ID: {examId}. Language: {language}.",
  "import.pev.success": "PEV data was successfully imported.",
  "import.pev.wrongCourseModules": "Modules are not linked to the course. Course ID: {courseId}. Modules IDs: {moduleIds}.",
  "import.pev.wrongExamSessionExams": "Exams are not linked to the exam session. Exam session ID: {examSessionid}. Exams IDs: {examIds}.",
  "import.pev.wrongModuleExams": "Exams are not linked to the module. Module ID: {moduleId}. Exams IDs: {examIds}.",
  "lifeExams.back": "Back",
  "lifeExams.book": "Book",
  "lifeExams.confirm": "Confirm",
  "lifeExams.label.displayFullyBooked": "Display also fully booked sessions",
  "lifeExams.label.register": "Select",
  "lifeExams.label.sesionFullyBooked": "No places available",
  "lifeExams.messages.courseNotFound": "The course was not found.",
  "lifeExams.messages.infoAlertAddUpdateOrConfirmPersonalData": "Please enter, update or confirm your personal data before booking an exam.",
  "lifeExams.messages.infoAlertExams": "Only free exam places in {lang} are displayed.",
  "lifeExams.messages.infoAlertExamSessions": "Only months with free exam places are displayed",
  "lifeExams.messages.noAvailableExams": "No available exams",
  "lifeExams.messages.warnAlertReservation": "Please note that your place is not reserved until payment is made.",
  "lifeExams.pay": "Book + Pay",
  "lifeExams.paymentErrorInitializing": "Error initializing payment",
  "lifeExams.redirectToMyVbv": "Redirect to MyVBV in {secondsLeft} seconds",
  "lifeExams.sessionAlreadyBooked": "Exam session already booked",
  "lifeExams.title": "Choose exam date",
  "lifeExams.transactionCancelled": "Transaction {transactionId} has been cancelled",
  "lifeExams.transactionFailed": "Transaction {transactionId} failed. Reason: ",
  "lifeExams.transactionPaid": "You are registered for the exam and will receive a booking confirmation by e-mail shortly.",
  "lifeExams.waitingList": "Waiting list",
  "location.button.new": "Add new location",
  "location.field.canton.placeholder": "Select a Canton",
  "location.field.canton": "Canton",
  "location.field.city": "City",
  "location.field.contactEmailAddress": "Contact Email",
  "location.field.contactName": "Contact Name",
  "location.field.contactPhoneNo": "Contact Phone No.",
  "location.field.languageRegions": "Language Regions",
  "location.field.linkToMap": "Location map",
  "location.field.name": "Name",
  "location.field.street": "Street",
  "location.field.zipCode": "Zip Code",
  "location.header": "Locations",
  "location.validation.idNotEmpty": "The Location ID can't be empty.",
  "location.validation.languageUnknown": "The Language is unknown. Please choose an existing language.",
  "location.validation.nameAlreadyExists": "Another Location with the same name already exists.",
  "location": "Location",
  "login.button.adminLogin": "Login VBV-Admin",
  "login.button.impressum": "Impressum",
  "login.button.impressumLink": "https://www.vbv.ch/de/impressum",
  "login.button.login": "Login",
  "login.error.errorLoadingAppRegistration": "Error retrieving configuration.",
  "login.text.external1": "Sign in to access the application.",
  "login.text.external2": "Please use a modern browser such as Chrome or Edge. This platform works exclusively with a notebook or desktop. It does not work with a tablet or mobile phone.",
  "login.text.externalWarn": "Important",
  "login.title.external": "Sign in as Candidate/Expert",
  "module.button.new": "Add new module",
  "module.dialog.confirmPublishDescription": "Are you sure you want to publish this module?",
  "module.dialog.noAvailableExams": "No exams available.",
  "module.dialog.noAvailableLocations": "No locations available.",
  "module.dialog.selectExams": "Select exams",
  "module.dialog.selectLocations": "Select locations",
  "module.field.abacusNumber": "Abacus number",
  "module.field.allowDocumentUpload": "Allow document upload",
  "module.field.allowOptions": "Allow options",
  "module.field.allowRegistrationOnlyOnce": "Available once",
  "module.field.allRoomsAssigned": "Room Assigned",
  "module.field.certificateValidity.FiveYears": "5 years",
  "module.field.certificateValidity.OneYear": "1 year",
  "module.field.certificateValidity.Unlimited": "Unlimited",
  "module.field.certificateValidity": "Certificate validity",
  "module.field.documentsUploaded": "Documents uploaded",
  "module.field.gradingRules.allExams": "All exams must be passed",
  "module.field.gradingRules.averageGrade": "Average grade",
  "module.field.gradingRules": "Grading rules",
  "module.field.moduleId": "Module ID",
  "module.field.moduleName": "Module name",
  "module.field.moduleNameDE": "Module name DE",
  "module.field.moduleNameEN": "Module name EN",
  "module.field.moduleNameFR": "Module name FR",
  "module.field.moduleNameIT": "Module name IT",
  "module.field.moduleType.mandatory": "Mandatory",
  "module.field.moduleType.optionalModule": "Optional module",
  "module.field.moduleType.processModule": "Process module",
  "module.field.moduleType": "Module type",
  "module.field.needsApproval": "Needs approval",
  "module.field.paymentState": "Payment status",
  "module.field.price": "Price in CHF",
  "module.field.verificationRequired": "Verification required",
  "module.header": "Modules",
  "module.moduleDetails": "Module details",
  "module.section.specifics": "Module specifics",
  "module.snackbar.successfulArchive": "The Module was archived successfully.",
  "module.snackbar.successfulDelete": "The Module was deleted successfully.",
  "module.snackbar.successfulPublish": "The Module was published successfully.",
  "module.validation.gradingRule.invalidValue": "Incorrect grading rule value.",
  "module.validation.idNotEmpty": "The Module ID can't be empty.",
  "module.validation.invalidStatusTransition": "This status transition is invalid.",
  "module.validation.invalidStatusValue": "Incorrect status value.",
  "module.validation.statusNotEmpty": "Status should not be empty.",
  "oralExamOption.kmu": "Small and medium-sized enterprises",
  "oralExamOption.none": "None",
  "oralExamOption.privathaushalte": "Private household",
  "paymentMethodSelector.form.button": "Pay using invoice",
  "paymentMethodSelector.item.creditCard": "Credit card / Twint",
  "paymentMethodSelector.item.invoice": "Invoice",
  "paymentMethodSelector.item.invoiceMessage": "Private address (CH)",
  "paymentMethodSelector.title": "Choose the payment method",
  "paymentStatus.paid.abacus": "Invoiced (Abacus)",
  "paymentStatus.paid.ePayment.cembraPay": "Paid (E-Payment: CembraPay)",
  "paymentStatus.paid.ePayment.creditCard": "Paid (E-Payment: Credit card / Twint)",
  "paymentStatus.refunded.abacus": "Refunded (Abacus)",
  "paymentStatus.refunded.ePayment.cembraPay": "Refunded (E-Payment: CembraPay)",
  "paymentStatus.refunded.ePayment.creditCard": "Refunded (E-Payment: Credit card / Twint)",
  "person.field.activateSpecificProfile": "Activate expert profile",
  "person.field.ahvNumber": "AHV Number",
  "person.field.bankAccount": "Bank Account",
  "person.field.birthDate": "Date of Birth",
  "person.field.ciceroNumber": "Cicero Number",
  "person.field.city": "Place of residence",
  "person.field.country": "Country",
  "person.field.displayName": "Name",
  "person.field.email": "Email",
  "person.field.employer": "Employer",
  "person.field.employerCity": "Employer City",
  "person.field.employerCountry": "Select the Employer's Country",
  "person.field.employerStreet": "Employer Street",
  "person.field.employerStreetNumber": "Employer Street Number",
  "person.field.employerZipCode": "Employer Zip Code",
  "person.field.firstName": "First Name",
  "person.field.gender.placeholder": "Select a Gender",
  "person.field.gender": "Gender",
  "person.field.homeCountry": "Home Country",
  "person.field.icon": "Actor symbol",
  "person.field.internalComment": "Internal comment",
  "person.field.lastName": "Last Name",
  "person.field.mobileNumber": "Mobile Number",
  "person.field.phoneNumber.placeholder": "Format: +41123456789",
  "person.field.phoneNumber": "Phone Number",
  "person.field.showOnlyExperts": "Show only experts",
  "person.field.street": "Street",
  "person.field.streetNumber": "Number",
  "person.field.zipCode": "Zip code",
  "person.section.address": "Private Address",
  "person.section.businessData": "Business Data",
  "person.section.expertDetails": "Expert specific details",
  "person.section.personalDetails": "Personal Details",
  "person.validation.ahvNumberAlreadyExists": "Another user with the same AHV number already exists.",
  "person.validation.ahvNumberNotValid": "The AHV number is invalid.",
  "person.validation.bankAccountNotEmpty": "The bank account can't be empty",
  "person.validation.ciceroNumberAlreadyExists": "Another user with the same Cicero number already exists.",
  "person.validation.ciceroNumberNotValid": "The Cicero number is invalid.",
  "person.validation.confirmEmailChange": "The email address was modified. This will also change the login email. Are you sure you want to continue?",
  "person.validation.emailAlreadyExists": "Another User with the same email already exists.",
  "person.validation.genderUnknown": "The Gender is unknown. Please choose an existing gender.",
  "person.validation.invalidEmployerZipCode": "Employer Zip Code is invalid.",
  "person.validation.invalidZipCode": "Zip code of the place of residence is invalid.",
  "person.validation.mandatoryExamRolesWithNoExams": "There are mandatory exam roles that doesn't have exams assigned. Please assign the missing exams.",
  "person.validation.personEdiIdNotEmpty": "The EDI Id can't be empty",
  "person.validation.personEmailAddressNotEmpty": "The email address can't be empty",
  "person.validation.repeatedRoles": "There are repeated roles. Please ensure there are not repeated roles.",
  "person.validation.typeUnknown": "The Person Type is unknown. Please choose an existing type.",
  "role.validation.roleUnknown": "Unknown role",
  "room.button.new": "New room assignment",
  "room.field.floor": "Floor",
  "room.field.isPcRoom": "Computer room",
  "room.field.name": "Name",
  "room.field.numberOfSeats": "Capacity",
  "room.header": "Room",
  "room.text.seats": " seats",
  "room.validation.idNotEmpty": "The Room ID can't be empty.",
  "room.validation.nameAlreadyExists": "Another room with the same name already exists.",
  "roomAssignment.button.new": "Assign a room",
  "roomAssignment.deleteConfirmation.title": "You are about to remove a preparation room. Please make sure that there is one preparation room assigned to this exam date.",
  "roomAssignment.field.isPreparationRoom": "Preparation room",
  "roomAssignment.field.room.placeholder": "Select a room",
  "roomAssignment.field.room": "Room",
  "roomAssignment.header": "Room assignment",
  "roomAssignment.validation.idNotEmpty": "The Room Assignment Id can't be empty",
  "scheduler.examSelectDialog.title": "Choose exam for the room",
  "scheduler.examSelectDialog.tooltip": "Set exam for all time slots",
  "scheduler.message.briefing": "Expert's briefing",
  "scheduler.message.exam": "Exam",
  "scheduler.message.noExperts": "No experts assigned",
  "scheduler.message.pause": "Pause",
  "scheduler.timeSlot.arrivalTime": "Arrival time",
  "selfcancellation.header": "Cancel module",
  "selfcancellation.text": "Attention: Please confirm that you wish to cancel your registration for the examination.",
  "startCertification.button.back": "BACK",
  "startCertification.button.finish": "FINISH",
  "startCertification.button.next": "NEXT",
  "startCertification.courseModuleExamsStep.header": "Select course, module and exams",
  "startCertification.examDataStep.header": "Select exam type, location and date",
  "startCertification.examDataStep.selectCompany": "Select your company",
  "startCertification.examDataStep.selectExamSession": "Select exam session",
  "startCertification.examDataStep.selectFachrichtung": "Select the main subject",
  "startCertification.examDataStep.selectLocationOralPart": "Select a location for the oral part of your exam",
  "startCertification.examDataStep.selectLocationWrittenPart": "Select a location for the written part of your exam",
  "startCertification.examDataStep.selectOralExamDate": "Select a date for the oral exam",
  "startCertification.examDataStep.selectWrittenExamDate": "Select a date for the written exam",
  "startCertification.locationDateStep.header": "Choose exam location and date",
  "startCertification.modulesDetailsStep.dialogHelperText": "Please complete the missing information and upload the required documents if necessary.",
  "startCertification.modulesDetailsStep.docsText1": "Please upload all documents that are required for this module.",
  "startCertification.modulesDetailsStep.docsText2": "If you are unable to upload the documents at this time, mark this below. We will assign you an appropriate task.",
  "startCertification.modulesDetailsStep.fillDetails": "Complete details",
  "startCertification.modulesDetailsStep.header": "Provide information and documents",
  "startCertification.modulesDetailsStep.helperText": "Please complete the missing information and upload the required documents for the selected modules.",
  "startCertification.modulesDetailsStep.isRepeater": "I am repeater",
  "startCertification.modulesDetailsStep.option.kmu": "SME",
  "startCertification.modulesDetailsStep.option.privathaushalte": "Private",
  "startCertification.modulesDetailsStep.option": "Option",
  "startCertification.modulesDetailsStep.tableTitle": "Selected modules",
  "startCertification.modulesDetailsStep.trainingProvider": "Training provider",
  "startCertification.modulesDetailsStep.willUploadDocsLater": "Upload documents later",
  "startCertification.moduleSelectionStep.header": "Select course, module and exams",
  "startCertification.moduleSelectionStep.helperText": "Please select a course and exam session to select the modules and exams you wish to register for.",
  "startCertification.moduleSelectionStep.priceColumn": "Price in CHF",
  "startCertification.moduleSelectionStep.removeButton": "Remove",
  "startCertification.moduleSelectionStep.selectButton": "Select",
  "startCertification.moduleSelectionStep.selectedModules": "Your selected modules",
  "startCertification.paymentAndCompletionStep.actionColumn": "Action",
  "startCertification.paymentAndCompletionStep.button.confirm": "Confirm booking",
  "startCertification.paymentAndCompletionStep.button.confirmed": "Confirmed",
  "startCertification.paymentAndCompletionStep.button.paid": "Paid",
  "startCertification.paymentAndCompletionStep.button.pay": "Pay",
  "startCertification.paymentAndCompletionStep.freeCancelDate": "free cancellation until ",
  "startCertification.paymentAndCompletionStep.generalInfo.cost1": "After that, if ",
  "startCertification.paymentAndCompletionStep.generalInfo.cost2bold": "you cancel your registration without good reason,",
  "startCertification.paymentAndCompletionStep.generalInfo.cost3": " you will be charged the full examination fee.",
  "startCertification.paymentAndCompletionStep.generalInfo.freeCancellation": "Registration is binding. You can cancel your registration without incurring any costs until the dates indicated above.",
  "startCertification.paymentAndCompletionStep.generalInfo.hveFAQLink": "https://www.vbv.ch/fileadmin/vbv/Dokumente/Bildungsabschluesse/Versicherungsfach/72047_PO_Versicherungsfachleute_D_2022.pdf",
  "startCertification.paymentAndCompletionStep.generalInfo.hveFAQLinkText": "FAQ federal professional certificate",
  "startCertification.paymentAndCompletionStep.generalInfo.intermediaryFAQLink": "https://www.vbv.ch/fileadmin/vbv/Dokumente/Bildungsabschluesse/Versicherungsvermittlung/FAQ_Vermi_Pruefungen_de.pdf",
  "startCertification.paymentAndCompletionStep.generalInfo.intermediaryFAQLinkText": "FAQ insurance intermediary",
  "startCertification.paymentAndCompletionStep.generalInfo.moreInformation1": "See the ",
  "startCertification.paymentAndCompletionStep.generalInfo.moreInformation2": " for more information.",
  "startCertification.paymentAndCompletionStep.header": "Payment and completion",
  "startCertification.paymentAndCompletionStep.hint": "Please note that your place in a module is not reserved until payment is made.",
  "startCertification.paymentAndCompletionStep.messages.transactionCancelled": "Transaction {id} cancelled",
  "startCertification.paymentAndCompletionStep.messages.transactionConfirmed": "Transaction {id} has been confirmed",
  "startCertification.paymentAndCompletionStep.messages.transactionFailed": "Transaction {id} failed",
  "startCertification.paymentAndCompletionStep.messages.transactionPaid": "Transaction {id} has been paid",
  "startCertification.paymentAndCompletionStep.messages.wrongTransactionId": "Invalid transaction ID {id}",
  "startCertification.paymentAndCompletionStep.moduleFullyBooked": "Fully booked",
  "startCertification.paymentAndCompletionStep.paymentConfirmationMessagePart1": "This can take up to a minute. This message will be auto dismissed when the payment has been confirmed.",
  "startCertification.paymentAndCompletionStep.paymentConfirmationMessagePart2": "If not, please contact VBV with the transaction ID: {datatransTrxId}",
  "startCertification.paymentAndCompletionStep.paymentConfirmationTitle": "Waiting for payment confirmation, please wait",
  "startCertification.paymentAndCompletionStep.removeModule": "Remove module",
  "startCertification.paymentAndCompletionStep.removeModuleConfirmation": "Do you want to remove the module?",
  "startCertification.paymentAndCompletionStep.summary": "Summary",
  "startCertification.personalDataStep.header": "Verify your data",
  "startCertification.policyDialog.accept.link": "privacy policy/GTC",
  "startCertification.policyDialog.accept.linkUrl": "https://www.vbv.ch/de/datenschutzbestimmungen",
  "startCertification.policyDialog.accept": "I hereby accept the ",
  "startCertification.policyDialog.text1": "I hereby acknowledge and consent to the following information being disclosed to my employer: Successful registration for an examination session, including the date of the examination session, the examination results, including grades/points and whether the examination was passed or failed, registration in the Cicero register ",
  "startCertification.policyDialog.text2": "This consent can be revoked at any time and freely vis-à-vis the Insurance Industry Vocational Training Association VBV in writing or by e-mail to vermittler@vbv-afa.ch.",
  "startCertification.uploadFilesStep.header": "Upload verification files",
  "table.noRecords": "No records found",
  "task.creationDate": "Creation Date",
  "task.deadline": "Deadline",
  "task.noInfo": "No pending tasks",
  "task.state": "Status",
  "task.type": "Type",
  "task.validation.deadlineMustBeLaterThanToday": "The Deadline must be later than today.",
  "task.validation.typeUnknown": "Task type unknown",
  "taskState.done": "Done",
  "taskState.inProgress": "In Progress",
  "taskState.toDo": "To Do",
  "taskType.cancellation": "Cancellation",
  "taskType.checkAvailability": "Hand in Availability",
  "taskType.checkCorrectionAvailability": "Enter availability for exam correction",
  "taskType.none": "None",
  "taskType.uploadDocuments": "Upload documents",
  "uploadDocumentsTask.header": "Upload documents task",
  "uploadDocumentsTask.instructions": "Please upload all documents required for this module and complete the task when you are done.",
  "user.noInfo": "No user info",
  "user.settings": "Settings",
  "userRoomAssignment.assignment": "Assignment",
  "userRoomAssignment.label.allExpertsSwitch": "Show all experts",
  "userRoomAssignment.label.fixed": "Fixed",
  "userRoomAssignment.label.fixedCorrectionExperts": "Fixed correction experts",
  "userRoomAssignment.label.fixedExperts": "Fixed experts (2x)",
  "userRoomAssignment.label.fixedProctors": "Fixed proctors (2x)",
  "userRoomAssignment.label.reserve": "Reserve",
  "userRoomAssignment.label.reserveCorrectionExperts": "Reserve correction experts",
  "userRoomAssignment.label.reserveExperts": "Reserve experts",
  "userRoomAssignment.label.reserveProctors": "Reserve proctors",
  "userRoomAssignment.label.roomFull": "Room is full",
  "userRoomAssignment.label.roomOverload": "Room is overloaded",
  "userRoomAssignment.placeholder.selectFixedExperts": "Select fixed experts",
  "userRoomAssignment.placeholder.selectFixedProctors": "Select fixed proctors",
  "userRoomAssignment.placeholder.selectReserveExperts": "Select reserve experts",
  "userRoomAssignment.placeholder.selectReserveProctors": "Select reserve proctors",
};
